import * as React from "react";
import { GenderDonut } from "./GenderDonut";
import { GenderColorLookup } from "./CTSAReportHelper";
import { Legends } from "./TeamCompositionLegends";
import "./TeamComposition.css";


interface Props {
    teamComposition?: {
        KL2PITotal, KL2AnyTotal, KCOMPPITotal, KCOMPAnyTotal,
        KL2PIFaculty, KL2PIClinician, KL2PIPostdoc, KL2PIStaff, KL2PIStudents,
        KL2AnyFaculty, KL2AnyClinician, KL2AnyPostdoc, KL2AnyStaff, KL2AnyStudents,
        KCOMPAnyFaculty, KCOMPAnyClinician, KCOMPAnyPostdoc, KCOMPAnyStaff, KCOMPAnyStudents,
        KCOMPPIFaculty, KCOMPPIClinician, KCOMPPIPostdoc, KCOMPPIStaff, KCOMPPIStudents,
        KL2PIClinicianPercentage, KL2AnyClinicianPercentage, KCOMPPIClinicianPercentage, KCOMPAnyClinicianPercentage
    };
    teamGenderComposition?: {
        KL2AnyGender
        KCOMPAnyGender,
        KL2PIGender,
        KCOMPPIGender
    }

}

class TeamComposition extends React.Component<Props, {}> {
    generateIcons = (result, keyLabel) => {
        if (result !== 'NA') {
            const int = Math.floor(result);
            const decimal = result - int;

            let arr;
            if (decimal === 0 || decimal < 0.1) {
                arr = Array.from({ length: int }, () => 1);
            } else {
                arr = [...Array.from({ length: int }, () => 1), 0];

            }
            return <div className="team-composition" style={{ borderRight: 'none' }}>
                {
                    arr.map((person, index) => person === 1 ?
                        <i className={`fa fa-user fa-1x person ${keyLabel.includes("kcom") && 'kcomp'}`} aria-hidden="true" key={`${keyLabel}-${index}`}></i>

                        : <i className={`fa fa-user fa-1x person half ${keyLabel.includes("kcom") && 'kcomp'}`} aria-hidden="true" key={`${keyLabel}-${index}`}></i>)
                }
                {
                    result < 1 ? result.toFixed(2) : result.toFixed(1)
                    //result.toFixed(2)
                }
            </div>
        } else {
            return <span>{result}</span>
        }

    }
    render() {
        const { KL2PITotal, KCOMPPITotal, KL2AnyTotal, KCOMPAnyTotal, KL2PIFaculty, KL2PIClinician, KL2PIPostdoc, KL2PIStaff, KL2PIStudents,
            KL2AnyFaculty, KL2AnyClinician, KL2AnyPostdoc, KL2AnyStaff, KL2AnyStudents,
            KCOMPAnyFaculty, KCOMPAnyClinician, KCOMPAnyPostdoc, KCOMPAnyStaff, KCOMPAnyStudents,
            KCOMPPIFaculty, KCOMPPIClinician, KCOMPPIPostdoc, KCOMPPIStaff, KCOMPPIStudents,
            KL2PIClinicianPercentage, KL2AnyClinicianPercentage, KCOMPPIClinicianPercentage, KCOMPAnyClinicianPercentage
        } = this.props.teamComposition;
        const { KL2AnyGender, KL2PIGender, KCOMPAnyGender, KCOMPPIGender } = this.props.teamGenderComposition;

        const showUnknown = KL2PIGender !== undefined && KL2PIGender['Unknown'] !== undefined && KL2PIGender['Unknown'].value > 0; 

        return <div>
            <div className="grid-title">
                <h4>R01 Team Composition</h4>
                <h5>*Team members paid in the first 12-month period of an R01 award</h5>
            </div>

            <div className="team-grid-container">
                <div className="role-header-1 header">
                    Non-PI on R01
            </div>
                <div className="role-header-2 no-border header">
                    PI on R01
            </div>
                <div className="col-header-1 header">
                    <span>KL2 Scholars<br />({`n=${KL2AnyTotal}`})</span>
                </div>
                <div className="col-header-2 header">
                    <span>K Comparison Scholars<br />({KCOMPAnyTotal === 0 ? 'n=0' : KCOMPAnyTotal < 5 ? 'n<5' : `n=${KCOMPAnyTotal}`})</span>
                </div>
                <div className="col-header-3 header">
                    <span>KL2 Scholars<br />({`n=${KL2PITotal}`})</span>
                </div>
                <div className="col-header-4  no-border header">
                    <span>K Comparison Scholars<br />({KCOMPPITotal === 0 ? 'n=0' : KCOMPPITotal < 5 ? 'n<5' : `n=${KCOMPPITotal}`})</span>
                </div>
                <div className="row-title-1 row-title">Faculty</div>
                <div className="row-title-2 row-title">Clinician</div>
                <div className="row-title-3 row-title">Postdoctoral Researcher</div>
                <div className="row-title-4 row-title">Staff</div>
                <div className="row-title-5 row-title">Student</div>
                <div className="row-title-6 row-title">Average Team Size</div>
                <div className="row-title-7 row-title">Gender Composition</div>
                <div className="cell-1">
                    {this.generateIcons(KL2AnyFaculty, 'kl2anyfac')}
                </div>
                <div className="cell-2">
                    {this.generateIcons(KL2AnyClinician, 'kl2anycli')}
                </div>
                <div className="cell-3">
                    {this.generateIcons(KL2AnyPostdoc, 'kl2anypostdoc')}
                </div>
                <div className="cell-4">
                    {this.generateIcons(KL2AnyStaff, 'kl2anystaff')}
                </div>
                <div className="cell-5">
                    {this.generateIcons(KL2AnyStudents, 'kl2anystu')}
                </div>
                <div className="cell-6 text">
                    {
                        (KL2AnyFaculty === 'NA' || KL2AnyClinician === 'NA' || KL2AnyPostdoc === 'NA' || KL2AnyStaff === 'NA' || KL2AnyStudents === 'NA') ? 'NA'
                            : (KL2AnyFaculty + KL2AnyClinician + KL2AnyPostdoc + KL2AnyStaff + KL2AnyStudents).toFixed(1)
                    }
                </div>
                <div className="cell-7 donut-container">

                    <GenderDonut data={KL2AnyGender} colors={GenderColorLookup} />

                </div>
                <div className="cell-8">
                    {this.generateIcons(KCOMPAnyFaculty, 'kcomanyfac')}


                </div>
                <div className="cell-9">
                    {this.generateIcons(KCOMPAnyClinician, 'kcomanycli')}


                </div>
                <div className="cell-10">
                    {this.generateIcons(KCOMPAnyPostdoc, 'kcomanypostdoc')}
                </div>
                <div className="cell-11">
                    {this.generateIcons(KCOMPAnyStaff, 'kcomanystaff')}

                </div>
                <div className="cell-12">
                    {this.generateIcons(KCOMPAnyStudents, 'kcomanystu')}
                </div>
                <div className="cell-13 text">
                    {
                        (KCOMPAnyFaculty === 'NA' || KCOMPAnyClinician === 'NA' || KCOMPAnyPostdoc === 'NA' || KCOMPAnyStaff === 'NA' || KCOMPAnyStudents === 'NA') ? 'NA'
                            : (KCOMPAnyFaculty + KCOMPAnyClinician + KCOMPAnyPostdoc + KCOMPAnyStaff + KCOMPAnyStudents).toFixed(1)
                    }

                </div>
                <div className="cell-14 donut-container">
                    {
                        KCOMPAnyTotal < 5 ? 'NA' :
                            <GenderDonut data={KCOMPAnyGender} colors={GenderColorLookup} />
                    }

                </div>
                <div className="cell-15">
                    {this.generateIcons(KL2PIFaculty, 'kl2pifac')}

                </div>
                <div className="cell-16">
                    {this.generateIcons(KL2PIClinician, 'kl2picli')}


                </div>
                <div className="cell-17">
                    {this.generateIcons(KL2PIPostdoc, 'kl2pipostdoc')}

                </div>
                <div className="cell-18">
                    {this.generateIcons(KL2PIStaff, 'kl2pistaff')}

                </div>
                <div className="cell-19">
                    {this.generateIcons(KL2PIStudents, 'kl2pistu')}

                </div>
                <div className="cell-20 text">
                    {
                        (KL2PIFaculty === 'NA' || KL2PIClinician === 'NA' || KL2PIPostdoc === 'NA' || KL2PIStaff === 'NA' || KL2PIStudents === 'NA') ? 'NA'
                            : (KL2PIFaculty + KL2PIClinician + KL2PIPostdoc + KL2PIStaff + KL2PIStudents).toFixed(1)
                    }
                </div>
                <div className="cell-21 donut-container">
                    {

                        <GenderDonut data={KL2PIGender} colors={GenderColorLookup} />

                    }
                </div>
                <div className="cell-22 no-border">
                    {this.generateIcons(KCOMPPIFaculty, 'kcomppifac')}


                </div>
                <div className="cell-23 no-border">
                    {this.generateIcons(KCOMPPIClinician, 'kcompicli')}


                </div>
                <div className="cell-24 no-border">
                    {this.generateIcons(KCOMPPIPostdoc, 'kcompipostdoc')}


                </div>
                <div className="cell-25 no-border">
                    {this.generateIcons(KCOMPPIStaff, 'kcompistaff')}

                </div>
                <div className="cell-26 no-border">
                    {this.generateIcons(KCOMPPIStudents, 'kcompistu')}
                </div>
                <div className="cell-27 no-border text">
                    {
                        (KCOMPPIFaculty === 'NA' || KCOMPPIClinician === 'NA' || KCOMPPIPostdoc === 'NA' || KCOMPPIStaff === 'NA' || KCOMPPIStudents === 'NA') ? 'NA'
                            : (KCOMPPIFaculty + KCOMPPIClinician + KCOMPPIPostdoc + KCOMPPIStaff + KCOMPPIStudents).toFixed(1)
                    }
                </div>
                <div className="cell-28 no-border donut-container">
                    {KCOMPPITotal < 5 ? 'NA' :
                        <GenderDonut data={KCOMPPIGender} colors={GenderColorLookup} />
                    }
                </div>
            </div>
            <Legends colors={GenderColorLookup} showUnknown={showUnknown} />
            {
                <ul>
                    <li>{KL2AnyClinicianPercentage} of R01 teams where KL2 scholars
had any role include clinicians</li>
                    <li>{KCOMPAnyClinicianPercentage} of R01 teams where comparison
scholars had any role include clinicians</li>
                    <li>{KL2PIClinicianPercentage} of R01 teams led by KL2 scholars who
are PIs include clinicians</li>
                    <li>{KCOMPPIClinicianPercentage} of R01 teams led by comparison scholars
who are PIs include clinicians</li>

                </ul>

            }


        </div>
    }
}
export default TeamComposition;
